import { render, staticRenderFns } from "./RaidNotif.vue?vue&type=template&id=6470390c&"
import script from "./RaidNotif.vue?vue&type=script&lang=js&"
export * from "./RaidNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports